import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import types from 'components/listings/listing/actions'
import loading from 'components/listings/listing/summary/row3/photos/images/loading.gif'

export const PicComp = ({ num, i, id, ml, status, updateStatus }) => {
  let srcSet = ''
  let url
  url = `https://HardinHomes.com/listing-pics/${ml}/${id}`
  if (status === 'hd') {
    srcSet = url.replace('medium@2x', 'full')
  }

  let src = loading
  if (status) {
    src = url
  }

  return (
    <img
      alt={`${i + 1} of ${num} for MLS listing ${ml}`}
      src={src}
      srcSet={srcSet}
      loading="lazy"
      onLoad={updateStatus}
    />
  )
}

PicComp.propTypes = {
  i: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  ml: PropTypes.string.isRequired,
  num: PropTypes.number.isRequired,
  status: PropTypes.string,
  updateStatus: PropTypes.func.isRequired,
}
PicComp.defaultProps = { status: undefined }

export const mapStateImage = ({ listings }, { id }) => ({
  status: listings.$$photos.get(id),
})

export const mapDispatch = (dispatch, { id }) => ({
  updateStatus: () => {
    dispatch({ id, type: types.LISTING_PHOTO_STATUS_SET })
  },
})

export default connect(mapStateImage, mapDispatch)(PicComp)
